import React, { useEffect, useState } from "react";
import { ElementState, Preview } from "@creatomate/preview";
import { Button, Icon, classnames } from "@culturehq/components";
import { Trans } from "app/utils";

interface FlipProps {
  activeElement: ElementState;
  preview: Preview;
}

const Flip: React.FC<FlipProps> = ({
  activeElement,
  preview
}) => {
  const [flipState, setFlipState] = useState({
    horizontal: false,
    vertical: false
  });

  const changeFlipProperty = async (
    property: "x_scale" | "y_scale",
    value: number
  ) => {
    await preview.applyModifications({
      [`${activeElement.source.id}.${property}`]: value
    });
  };

  const handleVerticalFlipClick = () => {
    setFlipState(prev => ({ ...prev, vertical: !prev.vertical }));
  };

  const handleHorizontalFlipClick = () => {
    setFlipState(prev => ({ ...prev, horizontal: !prev.horizontal }));
  };

  useEffect(() => {
    changeFlipProperty("y_scale", flipState.vertical ? -100 : 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flipState.vertical]);

  useEffect(() => {
    changeFlipProperty("x_scale", flipState.horizontal ? -100 : 100);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flipState.horizontal]);

  return (
    <div className="AlignmentOptions--Primary">
      <span className="chq-ffd--lb">
        <Trans>Flip</Trans>
      </span>
      <div className="pnl-align-option">
        <Button
          className={classnames("btn-text-align-option", {
            "btn-align-option-active": flipState.vertical
          })}
          onClick={handleVerticalFlipClick}
        >
          <Icon icon="flip" />
        </Button>
        <Button
          className={classnames("btn-text-align-option", {
            "btn-align-option-active": flipState.horizontal
          })}
          onClick={handleHorizontalFlipClick}
        >
          <Icon className="icon-flip" icon="flip" />
        </Button>
      </div>
    </div>
  );
};

export default Flip;
